export function formatDate(value: string): string {
  return [...value.replace(/\D/g, '')]
    .map((char, index) => (index === 1 || index === 3 ? `${char}/` : char))
    .join('')
    .substr(0, 10);
}
